import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue';
import MachineSummaryGraph from '@shell/components/formatter/MachineSummaryGraph.vue';

interface ClusterRow {
  stateParts?: { value: number }[];
  statusInfo?: { nodeCount?: number };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClusterMachineSummary',
  props: {
    row: {}
  },
  setup(__props: any) {

const props = __props;

// Machine states are fetched separately, so a list without them shows a count
const hasParts = computed(() => !!props.row?.stateParts?.length);
const nodeCount = computed(() => props.row?.statusInfo?.nodeCount || 0);

return (_ctx: any,_cache: any) => {
  return (!hasParts.value)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(nodeCount.value), 1))
    : (_openBlock(), _createBlock(MachineSummaryGraph, {
        key: 1,
        row: __props.row
      }, null, 8, ["row"]))
}
}

})